import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import {
  Container,
  CssBaseline,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
// import propTypes from "prop-types";

import Drawer from "../components/Drawer/Drawer";
import Toolbar from "../components/Toolbar/Toolbar";
import useStyles from "./styles/stylesDashboard";

import Estadisticas from "./Estadisticas";
import Envios from "./Envios";
import Direcciones from "./Direcciones";
import Paquetes from "./Paquetes";
import Destinatarios from "./Destinatarios";
import Recolecciones from "./Recolecciones";

// import Ordenes from "../Ordenes/Ordenes";
import Cotizacion from "./Cotizacion";
import { titles } from "../constants/constants";
import { useAuth0 } from "../hooks/react-auth0-spa";
import useSaldosAPI from "../hooks/useSaldosAPI";
import Cuenta from "./Cuenta";
import Admin from "./Admin";
import { SnackbarProvider } from "notistack";
import banner from "../images/banner.png";
// import history from "../../utils/history";

const Dashboard = () => {
  const [open, setOpen] = useState();
  const [currentItem, setCurrentItem] = useState();
  const { isAuthenticated, user, logout } = useAuth0();
  const [{ isError, isLoading }, doFetch] = useSaldosAPI();

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isLoading) {
      //TODO:Defaut cotizar
      setCurrentItem("cotizar");
      setOpen(true);
    }
  }, [isLoading, isAuthenticated]);
  useEffect(() => {
    if (user) {
      doFetch(user.sub);
    }
  }, [user, doFetch]);
  useEffect(() => {
    if (currentItem === "logout") logout();
  }, [currentItem, logout]);
  const handlerCurrentItem = (item) => {
    setCurrentItem(item);
  };

  /* end handlers definition */
  // console.log(, isLoading, isError);
  const classes = useStyles();

  // console.log(classes);
  return isLoading ? (
    <CircularProgress />
  ) : !isAuthenticated ? (
    <Redirect to="/" />
  ) : (
    <div className={classes.root}>
      <CssBaseline />
      <Toolbar
        // saldo={data.saldo}

        open={open}
        handleDrawerOpen={handleDrawerOpen}
        current={titles[currentItem]}
      />
      <Drawer
        open={open}
        currentItemHandler={handlerCurrentItem}
        handleDrawerClose={handleDrawerClose}
      />
      <main className={classes.content}>
        <div className={classes.appBarSpacer}>
        {<img src={banner} style={{width:'100%',marginTop:'56px'}} />}
          <Container
            maxWidth="xl"
            className={classes.container}
          >
            {/* {currentItem === "dashboard" && <Estadisticas />} */}
            {currentItem === "envios" && <Envios />}
            {currentItem === "recolecciones" && <Recolecciones />}
            {currentItem === "cotizar" && <Cotizacion />}
            {currentItem === "direcciones" && <Direcciones />}
            {currentItem === "paquetes" && <Paquetes />}
            {currentItem === "destinatarios" && <Destinatarios />}
            {currentItem === "estadisticas" && <Estadisticas />}
            {currentItem === "cuenta" && <Cuenta />}
            {currentItem === "admin" && (
              <SnackbarProvider maxSnack={3}>
                <Admin />
              </SnackbarProvider>
            )}
            {/* {currentItem === "ordenes" && <Ordenes />} */}
          </Container>
        </div>
        {isError ? (
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="error"
            message="hmmm"
          />
        ) : (
          <></>
        )}
      </main>
    </div>
  );
};

export default Dashboard;
